// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type OptionsStepQueryVariables = Types.Exact<{
  input: Types.PotentialOptionsInput;
}>;


export type OptionsStepQuery = { __typename?: 'Query', potentialOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, isParentOption: boolean, active: boolean, order: number, publishToUnderwriting: boolean, showInCheckout: boolean, checkoutOrder?: number | null | undefined, bidOutPercentage: number, type: { __typename?: 'GlobalOptionType', id: string, name: string, isElevation: boolean }, globalOption: { __typename?: 'GlobalOption', code: string, id: string, name: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, required: boolean, order: number, checkoutOrder?: number | null | undefined, overrideSubstepNumber?: number | null | undefined, active: boolean, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string }>, overrideStep?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, name: string }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }, optionDefaultsIf: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string }>, optionRequiredIf: Array<{ __typename?: 'ReadyPlanRequiredOption', id: string, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }> }>, readyPlan: { __typename?: 'ReadyPlan', id: string, development?: { __typename?: 'Development', id: string } | null | undefined }, latestVersion?: { __typename?: 'ReadyPlanOptionVersion', id: string, isUpstreamInactive: boolean } | null | undefined, draftVersion?: { __typename?: 'ReadyPlanOptionVersion', id: string, isNewFromUpstream: boolean, isUpstreamInactive: boolean } | null | undefined }> };

export type CreateOfferingReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, isParentOption: boolean, active: boolean, order: number, publishToUnderwriting: boolean, showInCheckout: boolean, checkoutOrder?: number | null | undefined, bidOutPercentage: number, type: { __typename?: 'GlobalOptionType', id: string, name: string, isElevation: boolean }, globalOption: { __typename?: 'GlobalOption', code: string, id: string, name: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, required: boolean, order: number, checkoutOrder?: number | null | undefined, overrideSubstepNumber?: number | null | undefined, active: boolean, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string }>, overrideStep?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, name: string }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }, optionDefaultsIf: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string }>, optionRequiredIf: Array<{ __typename?: 'ReadyPlanRequiredOption', id: string, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }> }>, readyPlan: { __typename?: 'ReadyPlan', id: string, development?: { __typename?: 'Development', id: string } | null | undefined }, latestVersion?: { __typename?: 'ReadyPlanOptionVersion', id: string, isUpstreamInactive: boolean } | null | undefined, draftVersion?: { __typename?: 'ReadyPlanOptionVersion', id: string, isNewFromUpstream: boolean, isUpstreamInactive: boolean } | null | undefined };

export const CreateOfferingReadyPlanOptionFragmentDoc = gql`
    fragment CreateOfferingReadyPlanOption on ReadyPlanOption {
  id
  name
  displayName
  isParentOption
  type {
    id
    name
    isElevation
  }
  active
  globalOption {
    ...Named
    code
  }
  optionGroup {
    id
    name
    isMultiOptionGroup
    isSingleOptionGroup
    groupPrerequisites {
      id
      name
    }
    required
    order
    checkoutOrder
    overrideStep {
      code
      name
    }
    overrideSubstepNumber
    group {
      id
      name
    }
    readyPlanLocation {
      id
      location {
        id
        displayLocationPath
      }
    }
    active
  }
  optionDefaultsIf {
    id
    name
  }
  optionPrerequisites {
    id
    name
    code
  }
  optionConflicts {
    id
    name
    code
  }
  optionConflictChildren {
    id
    name
    code
  }
  optionRequiredIf {
    id
    targetCombinations {
      id
      options {
        id
        name
      }
    }
  }
  order
  readyPlan {
    id
  }
  latestVersion {
    id
    isUpstreamInactive
  }
  draftVersion {
    id
    isNewFromUpstream
    isUpstreamInactive
  }
  publishToUnderwriting
  showInCheckout
  checkoutOrder
  bidOutPercentage
  readyPlan {
    id
    development {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const OptionsStepDocument = gql`
    query OptionsStep($input: potentialOptionsInput!) {
  potentialOptions(input: $input) {
    ...CreateOfferingReadyPlanOption
  }
}
    ${CreateOfferingReadyPlanOptionFragmentDoc}`;

/**
 * __useOptionsStepQuery__
 *
 * To run a query within a React component, call `useOptionsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionsStepQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOptionsStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OptionsStepQuery, OptionsStepQueryVariables> & ({ variables: OptionsStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OptionsStepQuery, OptionsStepQueryVariables>(OptionsStepDocument, options);
      }
export function useOptionsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OptionsStepQuery, OptionsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OptionsStepQuery, OptionsStepQueryVariables>(OptionsStepDocument, options);
        }
// @ts-ignore
export function useOptionsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OptionsStepQuery, OptionsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OptionsStepQuery, OptionsStepQueryVariables>;
export function useOptionsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OptionsStepQuery, OptionsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OptionsStepQuery | undefined, OptionsStepQueryVariables>;
export function useOptionsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OptionsStepQuery, OptionsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OptionsStepQuery, OptionsStepQueryVariables>(OptionsStepDocument, options);
        }
export type OptionsStepQueryHookResult = ReturnType<typeof useOptionsStepQuery>;
export type OptionsStepLazyQueryHookResult = ReturnType<typeof useOptionsStepLazyQuery>;
export type OptionsStepSuspenseQueryHookResult = ReturnType<typeof useOptionsStepSuspenseQuery>;
export type OptionsStepQueryResult = ApolloReactCommon.QueryResult<OptionsStepQuery, OptionsStepQueryVariables>;